import { t } from 'i18next';
import * as yup from 'yup';

import { testRequiredSchema } from 'core/schemas';
import { UsersOptions } from 'system/constants';

export const editUserBulkSchema = (requiredOption: UsersOptions) =>
  yup.object().shape({
    assignedCompany: yup
      .object()
      .shape({
        id: yup.number().nullable(),
        name: yup.string().nullable(),
      })
      .nullable()
      .test(
        ...testRequiredSchema(
          UsersOptions.CHANGE_ASSIGNED_COMPANY === requiredOption,
          t('labelAssignedCompany')
        )
      ),
    ranks: yup
      .array()
      .nullable()
      .test(
        ...testRequiredSchema(
          [UsersOptions.ADD_RANK, UsersOptions.REMOVE_RANK].includes(requiredOption),
          t('labelRank')
        )
      ),
    allowQuoteReleaseWithoutSendingEmail: yup.boolean().nullable(),
  });
